/* ============================================================================
   LAH — TELA DE MOTIVOS AO ESCOLHER "APENAS ARMACAO"
   Tema: Outubro (Pre Green Friday 2.0)

   ============================================================================
   A TRAVA E POR PRODUTO, NAO POR NAVEGADOR
   ============================================================================
   Antes a chave era unica para a loja inteira: quem visse o questionário no
   Lee de manha nao veria em nenhum outro modelo ate o dia seguinte.

   Isso derrubava justamente o caso que queremos pegar — o cliente que roda
   tres ou quatro modelos antes de decidir — e dava a impressao de que
   determinados produtos (Freddie, Anpa, Ton) nao tinham o questionário, sendo
   que eram apenas os ultimos da fila de testes.

   Agora a chave leva o handle do produto: uma vez por dia POR MODELO. O
   cliente indeciso e ouvido em cada um, e ninguem ve a mesma tela duas vezes
   no mesmo produto no mesmo dia.

   PARA TESTAR sem esperar o dia virar: acrescente ?lahteste=1 ao endereco. A
   trava do dia e ignorada enquanto esse parametro estiver na URL.

   ============================================================================
   A ORDEM DO FLUXO
   ============================================================================
   "Sem Grau - apenas armação" tem proximo passo vazio no metaobjeto, entao o
   configurador cai sozinho em Acessorios e depois no Resumo. Interceptando o
   clique aqui, a ordem fica:

     apenas armação -> QUESTIONARIO -> oferta de 30% -> acessorios -> resumo

   Nada disso depende de o produto ter clip-on: quem manda e o nome do item.

   ============================================================================
   SOMENTE EM OCULOS DE GRAU. Em oculos de sol, comprar so a armacao e compra
   normal, e o cupom de lentes de grau nao teria onde ser usado. O tipo chega
   em window.LAH_PRODUTO.tipo, preenchido pelo carregador.

   POR QUE INTERCEPTAR EM VEZ DE EDITAR O CONFIGURADOR: o fluxo de lentes e um
   componente Alpine grande e sensivel. Interceptamos na fase de CAPTURA e
   devolvemos o controle intacto. Removendo este arquivo, tudo volta ao
   original.

   ROTEAMENTO DOS MOTIVOS: "nao tenho receita" e "preciso atualizar" levam a
   mesma resposta, mudando so o titulo. "Consulta marcada" vai para a reserva —
   e o unico motivo em que o cliente ja sabe QUANDO tera a receita.
   ============================================================================ */

(function () {
    'use strict';

    var ITEM_SELECTOR = '.product-lens-select-item';
    var OVERLAY_ID = 'lah-frameonly';
    var STORAGE_BASE = 'lah_frameonly_last_seen';
    var TIPO_VALIDO = 'oculos';

    var REASON_MAP = {
        sem_receita: { step: 'receita', title: 'Você não precisa da receita agora' },
        receita_vencida: { step: 'receita', title: 'Dá tempo de atualizar depois' },
        consulta_marcada: { step: 'reserva', title: null },
        medo_encaixe: { step: 'encaixe', title: null },
        outra_otica: { step: 'outra_otica', title: null }
    };

    function normalize(text) {
        return (text || '')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toLowerCase()
            .trim();
    }

    var produto = window.LAH_PRODUTO || {};

    /* Oculos de sol nao entram — "oculos de sol" normalizado nao e igual a
       "oculos", entao a comparacao exata basta. */
    if (normalize(produto.tipo) !== TIPO_VALIDO) return;

    var STORAGE_KEY = STORAGE_BASE + ':' + (produto.handle || 'produto');
    var TESTE = window.location.search.indexOf('lahteste=1') !== -1;

    var overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    /* GREEN FRIDAY (Claude 23.0): sem questionario. O clique em "apenas
       armacao" abre direto a etapa "gf", criada aqui mesmo: curta, com os 4
       gatilhos que respondem as objecoes de quem leva so a armacao (troca
       gratis, envio rapido com grau, receita depois, 30% off nas lentes).
       Datas iguais as do lah-sem-lentes (window.LAH_OFERTA);
       ?lah_gf=1 testa antes. Fora do periodo, volta o questionario.
       O ultimo item mostra so a condicao (GF_PCT% off nas lentes em
       promocao), sem nome nem preco de produto. */
    var CFG_OF = window.LAH_OFERTA || {};
    var GF = (function () {
        if (/[?&]lah_gf=1\b/.test(window.location.search)) return true;
        var agora = new Date();
        return agora >= new Date(CFG_OF.gf_inicio || '2026-11-01T00:00:00-03:00') &&
               agora <= new Date(CFG_OF.gf_fim || '2026-11-30T23:59:59-03:00');
    })();

    var GF_PCT = parseInt(CFG_OF.gf_pct, 10) || 30;

    function criarEtapaGF() {
        if (overlay.querySelector('[data-lah-fo-step="gf"]')) return true;
        var caixa = overlay.querySelector('.lah-fo');
        if (!caixa) return false;

        var css = document.createElement('style');
        css.textContent =
            '.lah-fo-gf{display:none;text-align:left;}.lah-fo-gf.is-active{display:block;}' +
            '.lah-fo-gf__selo{display:inline-block;margin:0 0 12px;padding:5px 11px;border-radius:999px;background:#000;color:#d6f647;font-size:12px;font-weight:600;letter-spacing:.02em;}' +
            '.lah-fo-gf__t{margin:0 30px 16px 0;color:#000;font-size:21px;font-weight:700;line-height:1.2;letter-spacing:-.01em;}' +
            '.lah-fo-gf__lista{display:grid;gap:8px;margin:0 0 18px;padding:0;list-style:none;}' +
            '.lah-fo-gf__item{display:flex;align-items:center;gap:12px;padding:11px 14px;border-radius:12px;background:#f4f5f2;color:#000;font-size:14px;line-height:1.3;}' +
            '.lah-fo-gf__item b{display:block;font-size:15px;font-weight:700;}' +
            '.lah-fo-gf__item i{font-style:normal;color:rgba(0,0,0,.66);}' +
            '.lah-fo-gf__item svg{flex:none;width:22px;height:22px;}' +
            '.lah-fo-gf__item--destaque{background:#d6f647;}.lah-fo-gf__item--destaque i{color:rgba(0,0,0,.78);}' +
            '.lah-fo-gf__pct{display:inline-block;margin-right:6px;padding:1px 7px;border-radius:6px;background:#000;color:#d6f647;font-size:13px;}' +
            '.lah-fo-gf__cta{display:flex;align-items:center;justify-content:center;width:100%;margin:0;padding:16px;text-align:center;line-height:1.2;border:0;border-radius:999px;background:#000;color:#fff;font:inherit;font-size:16px;font-weight:600;cursor:pointer;}' +
            '.lah-fo-gf__sair{display:block;width:100%;margin-top:10px;padding:8px;text-align:center;border:0;background:none;color:rgba(0,0,0,.5);font:inherit;font-size:13px;text-decoration:underline;text-underline-offset:3px;cursor:pointer;}';
        document.head.appendChild(css);

        function ic(d) {
            return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
        }
        function item(icone, titulo, texto, destaque) {
            return '<li class="lah-fo-gf__item' + (destaque ? ' lah-fo-gf__item--destaque' : '') + '">' + ic(icone) +
                '<span><b>' + titulo + '</b><i>' + texto + '</i></span></li>';
        }

        var etapa = document.createElement('div');
        etapa.className = 'lah-fo__step lah-fo-gf';
        etapa.setAttribute('data-lah-fo-step', 'gf');
        etapa.innerHTML =
            '<span class="lah-fo-gf__selo">Green Friday · até 30/11</span>' +
            '<h2 class="lah-fo-gf__t" id="lah-fo-gf-title">Leve seus óculos completos, assim como +30&nbsp;mil clientes</h2>' +
            '<ul class="lah-fo-gf__lista">' +
            item('<path d="M4 12a8 8 0 0 1 13.7-5.6L20 9"/><path d="M20 4v5h-5"/><path d="M20 12a8 8 0 0 1-13.7 5.6L4 15"/><path d="M4 20v-5h5"/>',
                'Troca grátis', 'A 1ª troca é por nossa conta.', true) +
            item('<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
                'Envio rápido, mesmo com grau', 'Visão simples pronta em 1 dia útil.') +
            item('<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 14l2 2 4-4"/>',
                'Ainda sem exame?', 'Envie a receita depois.') +
            item('<path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
                '<span class="lah-fo-gf__pct">' + GF_PCT + '% OFF</span>nas lentes', 'Válido para as lentes em promoção.') +
            '</ul>' +
            '<button type="button" class="lah-fo-gf__cta" data-lah-fo-choose-lens>Escolher minhas lentes</button>' +
            '<button type="button" class="lah-fo-gf__sair" data-lah-fo-seguir>Seguir só com a armação</button>';

        var motivos = overlay.querySelector('[data-lah-fo-step="reasons"]');
        if (motivos) motivos.parentNode.insertBefore(etapa, motivos.nextSibling);
        else caixa.appendChild(etapa);
        return true;
    }

    if (GF) GF = criarEtapaGF();

    var pendingItem = null;
    var allowThrough = false;
    var shownThisFlow = false;

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function today() {
        var d = new Date();
        var m = d.getMonth() + 1;
        var day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }

    function seenToday() {
        if (TESTE) return false;

        try {
            return window.localStorage.getItem(STORAGE_KEY) === today();
        } catch (e) {
            return false; /* sem storage: mostra, que e o comportamento util */
        }
    }

    function markSeenToday() {
        try {
            window.localStorage.setItem(STORAGE_KEY, today());
        } catch (e) { /* segue sem persistir */ }
    }

    function isFrameOnly(el) {
        return normalize(el.getAttribute('data-item-name')).indexOf('apenas armacao') !== -1;
    }

    function showStep(stepName) {
        var steps = overlay.querySelectorAll('[data-lah-fo-step]');
        Array.prototype.forEach.call(steps, function (step) {
            var isReasons = step.getAttribute('data-lah-fo-step') === 'reasons';
            var match = step.getAttribute('data-lah-fo-step') === stepName;

            if (isReasons) {
                step.style.display = match ? 'block' : 'none';
            } else {
                step.classList.toggle('is-active', match);
            }
        });
    }

    function open(item) {
        pendingItem = item;
        overlay.hidden = false;
        overlay.classList.add('is-open');
        showStep(GF ? 'gf' : 'reasons');
        overlay.setAttribute('aria-labelledby', GF ? 'lah-fo-gf-title' : 'lah-fo-title');
        document.body.classList.add('hidden-scroll');

        markSeenToday();
        track('lens_frameonly_prompt', { produto: produto.handle || '', gf: GF });
    }

    function close() {
        overlay.classList.remove('is-open');
        overlay.hidden = true;
        document.body.classList.remove('hidden-scroll');
    }

    /* Devolve o clique ao configurador. Como "apenas armacao" tem proximo
       passo vazio, o Alpine leva direto para acessorios — e o resumo depois. */
    function proceed() {
        var item = pendingItem;
        allowThrough = true;
        close();

        if (item) {
            item.click();
        }

        allowThrough = false;
        pendingItem = null;
    }

    /* ---- Intercepta ANTES do Alpine (fase de captura) ---- */
    document.addEventListener('click', function (event) {
        if (allowThrough) return;

        var item = event.target.closest ? event.target.closest(ITEM_SELECTOR) : null;
        if (!item) return;
        if (!isFrameOnly(item)) return;
        if (shownThisFlow) return;
        if (seenToday()) return;

        event.preventDefault();
        event.stopPropagation();

        shownThisFlow = true;
        open(item);
    }, true);

    /* ---- Escolha do motivo ---- */
    overlay.addEventListener('click', function (event) {
        var target = event.target;

        var reasonBtn = target.closest('[data-lah-fo-reason]');
        if (reasonBtn) {
            var reason = reasonBtn.getAttribute('data-lah-fo-reason');
            var config = REASON_MAP[reason];
            if (!config) return;

            track('lens_frameonly_reason', { reason: reason });

            if (config.title) {
                var titleEl = overlay.querySelector('[data-lah-fo-answer-title]');
                if (titleEl) titleEl.textContent = config.title;
            }

            showStep(config.step);
            return;
        }

        if (target.closest('[data-lah-fo-choose-lens]')) {
            track('lens_frameonly_recovered', {});
            pendingItem = null;
            close();
            return;
        }

        /* Saida da etapa Green Friday: segue direto, sem a oferta extra do
           lah-sem-lentes (ela so escuta data-lah-fo-continue). */
        if (target.closest('[data-lah-fo-seguir]')) {
            track('lens_frameonly_continued', { gf: true });
            proceed();
            return;
        }

        if (target.closest('[data-lah-fo-continue]')) {
            track('lens_frameonly_continued', {});
            proceed();
            return;
        }

        if (target.closest('[data-lah-fo-back]')) {
            showStep('reasons');
            return;
        }

        if (target.closest('[data-lah-res-salvar]')) {
            return; /* o proprio lah-reserva.js cuida; nao fechamos a tela */
        }

        if (target.closest('[data-lah-fo-close]') || target === overlay) {
            track('lens_frameonly_dismissed', {});
            pendingItem = null;
            close();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
            track('lens_frameonly_dismissed', {});
            pendingItem = null;
            close();
        }
    });

    /* Reabrir o configurador reinicia a trava DE SESSAO, mas nao a do dia. */
    document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest('.openProductLens')) {
            shownThisFlow = false;
        }
    });
})();
